<ngx-spinner [fullScreen]="true" size="medium" bdColor="rgba(255, 255, 255, 0.9)"
    template='<img src="../../../assets/img/loader.gif" alt="">'>
    <p style="font-size: 20px; color: #721374;margin-top:10px;font-weight: 600;">{{message}}</p>
</ngx-spinner>